module.exports = __webpack_public_path__ + "static/img/serve4.91e60db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/IncentiveTravel/serve4.png
// module id = kSnn
// module chunks = 1